/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import React from 'react'
import { createRoot } from 'react-dom/client'
import { NotificationProvider, Starc } from '@az/starc-ui'
import { Authentication, SessionTimer } from '@az/auth-ping'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './i18n'
import {
  AUTH_CLIENT_ID,
  AUTH_PKCE_LOGIN_URL,
  AUTH_REDIRECT_URI,
  AUTH_ROOT,
  AUTH_SCOPE,
  FALL_BACK_URI
} from './environment'
import { MINUTE_MS } from './constants'

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Starc theme="starc" defaultColorMode="dark">
      <NotificationProvider>
        <Authentication
          baseUrl={AUTH_ROOT}
          publicClientId={AUTH_CLIENT_ID}
          redirectUri={AUTH_REDIRECT_URI || FALL_BACK_URI}
          scope={encodeURI(AUTH_SCOPE)}
          skipAuthorization
          pkceLoginURL={AUTH_PKCE_LOGIN_URL}
        >
          {({ authenticated, disabledForDevelopment }) => {
            if (authenticated || disabledForDevelopment) {
              return (
                <>
                  {<SessionTimer timerLength={30 * MINUTE_MS} />}
                  <App />
                </>
              )
            } else {
              return <div></div>
            }
          }}
        </Authentication>
      </NotificationProvider>
    </Starc>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
